import { reachYandexMetrikaGoal } from '@minibook/shared';

/** Идентификаторы JS-целей в Яндекс.Метрике (завести в кабинете счётчика). */
const PWA_METRIKA_GOALS = {
  offerViewed: 'pwa_install_offer_viewed',
  buttonClicked: 'pwa_install_button_clicked',
  promptAccepted: 'pwa_install_prompt_accepted',
  promptDismissed: 'pwa_install_prompt_dismissed',
  appInstalled: 'pwa_app_installed',
} as const;

function trackPwaGoal(goal: (typeof PWA_METRIKA_GOALS)[keyof typeof PWA_METRIKA_GOALS]): void {
  reachYandexMetrikaGoal(goal);
}

export function trackPwaInstallOfferViewed(): void {
  trackPwaGoal(PWA_METRIKA_GOALS.offerViewed);
}

export function trackPwaInstallButtonClicked(): void {
  trackPwaGoal(PWA_METRIKA_GOALS.buttonClicked);
}

export function trackPwaInstallPromptAccepted(): void {
  trackPwaGoal(PWA_METRIKA_GOALS.promptAccepted);
}

export function trackPwaInstallPromptDismissed(): void {
  trackPwaGoal(PWA_METRIKA_GOALS.promptDismissed);
}

export function trackPwaAppInstalled(): void {
  trackPwaGoal(PWA_METRIKA_GOALS.appInstalled);
}
